const wholeNumberFormatter = new Intl.NumberFormat('en-US', {
  maximumFractionDigits: 0,
});

const glucoseSourceLabels = [
  ['APPLE_HEALTH', 'Apple Health'],
  ['HEALTH_CONNECT', 'Health Connect'],
] as const;

export function formatGlucoseValue(value: number): string {
  return wholeNumberFormatter.format(value);
}

export function formatGlucoseSources(
  sources: readonly (string | null | undefined)[],
): string {
  const presentSources = new Set(sources);
  const labels = glucoseSourceLabels.flatMap(([source, label]) =>
    presentSources.has(source) ? [label] : [],
  );
  return labels.join(' + ') || 'Source unavailable';
}
